import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../shared/hoc/createAdminPage'
import {AVAILABLE_OR_NOT, FACILITY_CATEGORY, NUMBER_OF_TIMES_TO_STAY, RESERVATION_TYPE} from '../../../CodeMaster'
import {
    AdminReserveLocationState,
    AgentReservationInfo,
    ManagerReservationInfo,
    ReservationInfo,
    RidgeInfo,
} from './AdminReserveInterfaces'
import lsHelper from './AdminReserveLocationStateHelper'
import moment, {Moment} from 'moment'
import {Id, StickyDiv} from '../components/ReservationTimelineView'
import {AdminTimelineItem} from './AdminReservationTimelineView'
import {DisplaySizeValue} from '../../../styledComponents/Constants'
import {Box, DialogActions, IconButton, Slide, Snackbar, SnackbarCloseReason,} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import {TransitionProps} from '@mui/material/transitions/transition';
import {
    FlexStartRowFlexContainer,
    FullWidthColumnFlexContainer,
    FullWidthLeftColumnFlexContainer,
    FullWidthRowFlexContainer,
} from '../../../styledComponents/FlexComponents'
import {AdminAgentReserveSteps, AdminManagerReserveSteps, AdminReserveStepper} from './AdminReserveStepper'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {FacilityRentalType, ReservationClass} from '../ReservationInterfaces'
import FacilitiesRepository from '../../facilities/FacilitiesRepository'
import {Nullable, Optional} from '../../../app/TypeHelpers'
import ARFacilityInfoDetailsComponent from './AdminReserveComponents/ARFacilityInfoDetailsComponent'
import FacilityForAdmin from '../../facilities/FacilityForAdmin'
import FacilityCategory from '../../facilities/FacilityCategory'
import NatCurrentDateTimeRepo
    from '../../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    FacilityCategoryFilter,
    FacilityCategoryWithSelectState,
} from './AdminReserveComponents/SelectFacility/ARFacilityCategoryFilter'
import {DateFilter} from './AdminReserveComponents/SelectFacility/ARDateFilter'
import ARReservationStatusViewOvernight, {
    OvernightFacilityReserveAvailability,
    StatusType,
} from './AdminReserveComponents/SelectFacility/ARReservationStatusViewOvernight'
import ARReservationStatusViewDuration, {
    DurationFacilityReserveAvailability,
} from './AdminReserveComponents/SelectFacility/ARReservationStatusViewDuration'
import {ReservationsRepositoryForAdmin} from './ReservationsRepositoryForAdmin'
import {formatDateLocal} from '../../../formatters/formatMoment'
import AdminReserveAvailabilityOvernight from './AdminReserveAvailabilityOvernight'
import AdminReserveAvailabilityDuration from './AdminReserveAvailabilityDuration'
import {convertToFacilityId} from '../helpers/helpers'
import {createUUID} from '../../../stringHelper/stringHelpers'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {calculateReservationType} from '../reservationTypeCalculator'
import {
    ARSelectFacilityInputFormOvernight,
} from './AdminReserveComponents/SelectFacility/ARSelectFacilityInputFormOvernight'
import ARSelectFacilityInputFormDuration
    from './AdminReserveComponents/SelectFacility/ARSelectFacilityInputFormDuration'
import NatRidgeRepo from '../../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import {NatGetRidge} from '../../../__NoAutomatedTests/components/ridge/repository/NatGetRidge'
import {isIE, isMobile} from 'react-device-detect'
import {AdminPageHeadingArea} from '../../shared/pageBaseComponents/AdminPageHeadingArea'
import {StyledDialogTitle} from './AdminReserveComponents/SelectFacility/ARStyledComponents'
import CloseIcon from '@mui/icons-material/Close'
import {
    getYearAfterNextDateFac,
    getYearDateFac,
    judgeAuthorityCheck,
} from '../../../__NoAutomatedTests/common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import FormErrorMessage, {MessagePair} from '../../shared/forms/FormErrorMessage'
import {Messages} from '../../../Messages'
import HolidaysRepository from '../../HolidaysRepository'
import {formatForDateInput} from '../../../formatters/formatDate'
import {Location} from 'react-router-dom'

export interface StatusInOneDay {
    date: Moment
    status: StatusType
}

export interface OvernightFacilityDailyStatus {
    id: number
    name: string
    stayPossibleDateCount: number
    dailyStatus?: StatusInOneDay[]
}

export interface CurrentItemOvernight {
    facilityId: number
    startDate: Moment
    stayCount: NUMBER_OF_TIMES_TO_STAY
}

interface Props {
    classification: ReservationClass
    condominiumCd: string
    location: Location<AdminReserveLocationState>
    facilitiesRepo: FacilitiesRepository
    currentDateTimeRepo: NatCurrentDateTimeRepo
    reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    ridgeRepo: NatRidgeRepo
    holidaysRepo: HolidaysRepository
}

interface State {
    areaWidth: number
    today: Nullable<moment.Moment>
    facilities: FacilityForAdmin[]
    facilityCategories: FacilityCategoryWithSelectState[]
    ridgeInfos: RidgeInfo[]

    selectedDate: Optional<moment.Moment>
    timelineInitialDateTime: Nullable<moment.Moment>
    selectedFacilityId: Nullable<number>

    reserveAvailabilitiesOvernight: OvernightFacilityDailyStatus[]
    reserveAvailabilitiesDuration: DurationFacilityReserveAvailability[]

    currentItemDuration: AdminTimelineItem | null
    currentItemOvernight: CurrentItemOvernight | null
    reservationTitle: string
    reservationType: Nullable<RESERVATION_TYPE>

    editMode: boolean
    illegalDateSelected: boolean

    limitStartDateTime: Optional<moment.Moment>
    limitEndDateTime: Optional<moment.Moment>

    holidays: Nullable<string[]>
}

class AdminReserveSelectFacilityPage extends Component<Props & AdminPagePropsSet, State> {

    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        this.handleResize = this.handleResize.bind(this)
        this.handleChangeDate = this.handleChangeDate.bind(this)
        this.handleChangeCategory = this.handleChangeCategory.bind(this)

        this.handleSubmitDuration = this.handleSubmitDuration.bind(this)
        this.handleSubmitOvernight = this.handleSubmitOvernight.bind(this)
        this.handleTimeLineFacilityNameClick = this.handleTimeLineFacilityNameClick.bind(this)
        this.handleTimelineClick = this.handleTimelineClick.bind(this)
        this.handleReservationAvailableOvernight = this.handleReservationAvailableOvernight.bind(this)
        this.handleFacilityInfoDialogClose = this.handleFacilityInfoDialogClose.bind(this)
        this.handleChangeReservationTitle = this.handleChangeReservationTitle.bind(this)
        this.handleChangeReservationTerm = this.handleChangeReservationTerm.bind(this)
        this.handleChangeStayCount = this.handleChangeStayCount.bind(this)
        this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)

        this.state = {
            areaWidth: 0,
            currentItemDuration: null,
            currentItemOvernight: null,
            reservationTitle: '',
            selectedFacilityId: null,
            facilityCategories: [],
            facilities: [],
            ridgeInfos: [],
            selectedDate: undefined,
            timelineInitialDateTime: null,
            today: null,
            reservationType: null,

            reserveAvailabilitiesOvernight: [],
            reserveAvailabilitiesDuration: [],

            editMode: false,
            illegalDateSelected: false,

            limitStartDateTime: undefined,
            limitEndDateTime: undefined,

            holidays: null,
        }
    }

    async componentDidMount(): Promise<void> {
        window.addEventListener('resize', this.handleResize)
        await this.initializePage()
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.handleResize)
    }

    async componentDidUpdate(
        prevProps: Readonly<Props & AdminPagePropsSet>, prevState: Readonly<State>,
    ): Promise<void> {
        if (prevProps.classification !== this.props.classification) {
            await this.initializePage()
        }
    }

    private async initializePage(): Promise<void> {
        try {
            await this.props.eventEmitter.showLoading()

            const {facilitiesRepo, currentDateTimeRepo, ridgeRepo, condominiumCd, classification} = this.props

            const currentDateTime = await currentDateTimeRepo.getCurrentDateTime()
            if (!currentDateTime || !currentDateTime.details) {
                return
            }
            const today = moment(`${currentDateTime.details.currentDateTime}`)

            const searchFacilityResponse: Nullable<FacilityForAdmin[]> = await this.props.asyncCallFunction(
                facilitiesRepo.getPublicFacilitiesForAdmin.bind(facilitiesRepo, condominiumCd),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (searchFacilityResponse === null) {
                return
            }
            const facilities: FacilityForAdmin[] = searchFacilityResponse

            const ridgeResponse: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
                ridgeRepo.getRidgeList.bind(ridgeRepo, condominiumCd),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (ridgeResponse === null || ridgeResponse.details === null) {
                return
            }
            const ridgeInfos: RidgeInfo[] = ridgeResponse.details

            const locationStateData =
                extractDataFromLocationState(facilities, this.props.location.state, today, classification)

            const facilityCategories: FacilityCategory[] = facilities
                .map(facility => {
                    const hasValue = FACILITY_CATEGORY.values().some(item => item.value === `${facility.categoryId}`)
                    const displayOrder =
                        hasValue
                            ? FACILITY_CATEGORY.codeToEnumConstants(`${facility.categoryId}`).displayOrder
                            : 0
                    return {
                        ...facility,
                        displayOrder: displayOrder,
                    }
                })
                .sort((facilityWidhDisplayOrderA, facilityWidhDisplayOrderB) => {
                    return facilityWidhDisplayOrderA.displayOrder - facilityWidhDisplayOrderB.displayOrder
                })
                .map(facility => {
                    return {
                        categoryId: facility.categoryId,
                        categoryName: facility.categoryName,
                    } as FacilityCategory
                })
                .filter((category, index, array) => {
                    return array.map(item => item.categoryId).indexOf(category.categoryId) === index
                })

            const categoryWithSelectStateList: FacilityCategoryWithSelectState[] = facilityCategories
                .map(item => {
                    return {
                        facilityCategory: item,
                        selected: (facilityCategories.length === 1),
                    }
                })
                .map(item => {
                    const selectedThisInLocationState =
                        (locationStateData.selectedCategoryIdList.includes(item.facilityCategory.categoryId))
                    return {
                        facilityCategory: item.facilityCategory,
                        selected: selectedThisInLocationState || (facilityCategories.length === 1),
                    }
                })

            const timelineInitialDateTime = locationStateData.selectedDate
                ? locationStateData.selectedDate.clone().hour(8).minutes(0)
                : null

            const editMode: boolean = judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_AGENT_RESERVE)

            const minDate: string = getYearDateFac()
            const maxDate: string = getYearAfterNextDateFac(currentDateTime.details.currentDateTime)
            const holidays: Nullable<string[]> =
                await this.getHolidays(formatForDateInput(minDate), formatForDateInput(maxDate))

            this.setState({
                currentItemDuration: locationStateData.currentItemDuration,
                currentItemOvernight: locationStateData.currentItemOvernight,
                selectedDate: locationStateData.selectedDate,
                timelineInitialDateTime: timelineInitialDateTime,
                reservationType: locationStateData.reservationType,
                reservationTitle: locationStateData.reservationTitle,
                today: today,
                facilityCategories: categoryWithSelectStateList,
                facilities: facilities,
                ridgeInfos: ridgeInfos,
                areaWidth: this.calcAreaWidth(),
                editMode: editMode,
                holidays: holidays,
            }, () => this.handleChangeCategory(this.state.facilityCategories))
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async getHolidays(startDate: string, endDate: string): Promise<Nullable<string[]>> {
        try {
            return await this.props.asyncCallFunction(
                this.props.holidaysRepo.getHolidays.bind(
                    this.props.holidaysRepo,
                    startDate,
                    endDate,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        } catch (e) {
            throw e
        }
    }

    calcAreaWidth(): number {
        if (isMobile) {
            return 1200 - 30 - 300
        }

        if (window.innerWidth < DisplaySizeValue.AdminWidthMin + 30) {
            return DisplaySizeValue.AdminWidthMin - 300
        }

        if (window.innerWidth > DisplaySizeValue.AdminWidthMax + 30) {
            return DisplaySizeValue.AdminWidthMax - 300
        }
        return window.innerWidth - 30 - 300
    }

    extractLoadingItemsOvernight(
        facilities: { id: number, name: string, stayPossibleDateCount: Nullable<number> }[],
    ): OvernightFacilityDailyStatus[] {
        return facilities.map(facility => {
            if (!facility.stayPossibleDateCount) {
                throw new Error('stayPossibleDateCount is null')
            }
            return {
                id: facility.id,
                name: facility.name,
                stayPossibleDateCount: facility.stayPossibleDateCount,
                dailyStatus: undefined,
            }
        })
    }

    extractLoadingItemsDuration(
        facilities: { id: number, name: string }[],
        date: Optional<moment.Moment>,
    ): DurationFacilityReserveAvailability[] {
        return facilities.map(facility => {
            if (!date) {
                return {
                    ...facility,
                    timeLineItems: [],
                }
            }
            if (isIE) {
                return {
                    ...facility,
                    timeLineItems: [
                        {
                            type: 'loading',
                            id: `${facility.id}-loading1`,
                            group: facility.id,
                            contents: '',
                            start_time: date.clone().hour(0).valueOf(),
                            end_time: date.clone().hour(12).valueOf(),
                        },
                        {
                            type: 'loading',
                            id: `${facility.id}-loading2`,
                            group: facility.id,
                            contents: 'データ取得中…',
                            start_time: date.clone().hour(12).valueOf(),
                            end_time: date.clone().add(1, 'day').valueOf(),
                        },
                    ],
                }
            }
            return {
                ...facility,
                timeLineItems: [{
                    type: 'loading',
                    id: `${facility.id}-loading`,
                    group: facility.id,
                    contents: 'データ取得中…',
                    start_time: date.clone().hour(0).valueOf(),
                    end_time: date.clone().add(1, 'day').valueOf(),
                }],
            }
        })
    }

    updateReserveAvailabilityOvernight(): Promise<void>[] {
        const {selectedDate, reserveAvailabilitiesOvernight} = this.state
        if (!selectedDate) {
            return []
        }

        const {reservationsRepoForAdmin, condominiumCd} = this.props

        return reserveAvailabilitiesOvernight.map(facility => {
            return this.props.asyncCallFunction(
                reservationsRepoForAdmin.getReserveStatusForOvernight.bind(
                    reservationsRepoForAdmin,
                    condominiumCd,
                    facility.id,
                    formatDateLocal(selectedDate),
                    7,
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            ).then((response: Nullable<AdminReserveAvailabilityOvernight>) => {
                if (!response) {
                    return
                }
                const dailyStatus = judgeStatusTypesOvernight(response, selectedDate, 7)

                this.setState((prevState) => {
                    const updateIndex =
                        prevState.reserveAvailabilitiesOvernight
                            .findIndex(availability => availability.id === facility.id)
                    if (updateIndex === -1) {
                        return {...prevState}
                    }
                    return {
                        reserveAvailabilitiesOvernight: [
                            ...prevState.reserveAvailabilitiesOvernight.slice(0, updateIndex),
                            {
                                ...prevState.reserveAvailabilitiesOvernight[updateIndex],
                                dailyStatus: dailyStatus,
                            },
                            ...prevState.reserveAvailabilitiesOvernight.slice(updateIndex + 1),
                        ],
                    }
                })
            })
        })
    }

    updateReserveAvailabilityDuration(): Promise<void>[] {
        const {selectedDate, reserveAvailabilitiesDuration} = this.state
        if (!selectedDate) {
            return []
        }

        const {reservationsRepoForAdmin, condominiumCd} = this.props

        return reserveAvailabilitiesDuration.map(facility => {
            return this.props.asyncCallFunction(
                reservationsRepoForAdmin.getReserveStatusForDurationRental.bind(
                    reservationsRepoForAdmin,
                    condominiumCd,
                    convertToFacilityId(facility.id),
                    `${formatDateLocal(selectedDate)}T00:00`,
                    `${formatDateLocal(selectedDate.clone().add(1, 'days'))}T24:00`,
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            ).then((response: Nullable<AdminReserveAvailabilityDuration>) => {
                if (response === null) {
                    return
                }

                this.setState((prevState) => {
                    const updateIndex =
                        prevState.reserveAvailabilitiesDuration
                            .findIndex(availability => availability.id === facility.id)
                    if (updateIndex === -1) {
                        return {...prevState}
                    }
                    const others: AdminTimelineItem[] =
                        response.otherReserves.map(otherReservation => {
                            return {
                                id: createUUID(),
                                type: 'otherReservation',
                                group: facility.id,
                                contents: '',
                                tip: `${formatTimelineItemTooltip(otherReservation.occupancyStartDateTime)} 〜 ${formatTimelineItemTooltip(otherReservation.occupancyEndDateTime)}`,
                                start_time: moment(otherReservation.occupancyStartDateTime).valueOf(),
                                end_time: moment(otherReservation.occupancyEndDateTime).valueOf(),
                            } as AdminTimelineItem
                        })

                    const outOfHours: AdminTimelineItem[] =
                        response.outOfHours.map(outOfHour => {
                            return {
                                id: createUUID(),
                                type: 'outsideHours',
                                group: facility.id,
                                contents: '',
                                tip: `${formatTimelineItemTooltip(outOfHour.startDateTime)} 〜 ${formatTimelineItemTooltip(outOfHour.endDateTime)}`,
                                start_time: moment(outOfHour.startDateTime).valueOf(),
                                end_time: moment(outOfHour.endDateTime).valueOf(),
                            } as AdminTimelineItem
                        })

                    return {
                        reserveAvailabilitiesDuration: [
                            ...prevState.reserveAvailabilitiesDuration.slice(0, updateIndex),
                            {
                                ...prevState.reserveAvailabilitiesDuration[updateIndex],
                                timeLineItems: [...outOfHours, ...others],
                            },
                            ...prevState.reserveAvailabilitiesDuration.slice(updateIndex + 1),
                        ],
                    }
                })

            })
        })
    }

    handleChangeDate(date: moment.Moment): void {
        this.setState({
            selectedDate: date,
            timelineInitialDateTime: date.clone().hour(8).minute(0),
            limitStartDateTime: date.clone().hour(0).minute(0),
            limitEndDateTime: date.clone().hour(23).minute(59),
            reserveAvailabilitiesDuration:
                this.extractLoadingItemsDuration(this.state.reserveAvailabilitiesDuration, date),
            reserveAvailabilitiesOvernight:
                this.extractLoadingItemsOvernight(this.state.reserveAvailabilitiesOvernight),
        }, async () => {
            await Promise.all([
                ...this.updateReserveAvailabilityOvernight(),
                ...this.updateReserveAvailabilityDuration(),
            ])
        })
    }

    handleChangeCategory(facilityCategories: FacilityCategoryWithSelectState[]): void {
        const targetCategoryIdList: number[] = this.extractTargetCategories(facilityCategories)

        this.setState(prevState => {
            const reserveAvailabilitiesOvernight: OvernightFacilityDailyStatus[] =
                this.extractLoadingItemsOvernight(
                    this.extractFilteredFacilitiesOvernight(prevState.facilities, targetCategoryIdList)
                        .map(facility => ({
                            id: facility.facilityId,
                            name: facility.facilityName,
                            stayPossibleDateCount: facility.stayPossibleDateCount,
                        })),
                )
            const reserveAvailabilitiesDuration: DurationFacilityReserveAvailability[] =
                this.extractLoadingItemsDuration(
                    this.extractFilteredFacilitiesDuration(prevState.facilities, targetCategoryIdList)
                        .map(facility => ({id: facility.facilityId, name: facility.facilityName})),
                    prevState.selectedDate,
                )
            return {
                facilityCategories: facilityCategories,
                reserveAvailabilitiesOvernight: reserveAvailabilitiesOvernight,
                reserveAvailabilitiesDuration: reserveAvailabilitiesDuration,
            }
        }, async () => {
            await Promise.all([
                ...this.updateReserveAvailabilityOvernight(),
                ...this.updateReserveAvailabilityDuration(),
            ])
            this.setState(prevState => {
                const {currentItemDuration, reserveAvailabilitiesDuration} = prevState
                return {
                    currentItemDuration: currentItemDuration
                        ? checkErrorReservation(
                            this.props.classification,
                            currentItemDuration,
                            reserveAvailabilitiesDuration)
                        : null,
                }
            })
        })
    }

    private extractFilteredFacilitiesOvernight(
        facilities: FacilityForAdmin[], targetCategoryIdList: number[],
    ): FacilityForAdmin[] {
        return facilities
            .filter(facility => facility.stayAvailability)
            .filter(facility => targetCategoryIdList.includes(facility.categoryId))
    }

    private extractFilteredFacilitiesDuration(
        facilities: FacilityForAdmin[], targetCategoryIdList: number[],
    ): FacilityForAdmin[] {
        return facilities
            .filter(facility => !facility.stayAvailability)
            .filter(facility => targetCategoryIdList.includes(facility.categoryId))
    }

    private extractTargetCategories(facilityCategories: FacilityCategoryWithSelectState[]): number[] {
        return facilityCategories
            .filter(category => category.selected)
            .map(category => category.facilityCategory.categoryId)
    }

    handleResize(): void {
        const areaWidth = this.calcAreaWidth()
        if (this.state.areaWidth !== areaWidth) {
            this.setState({areaWidth: areaWidth})
        }
    }

    handleTimelineClick(groupId: Id, itemId: Id | null, time: moment.Moment): void {
        const {reserveAvailabilitiesDuration, selectedDate} = this.state
        const {classification} = this.props

        const items = reserveAvailabilitiesDuration
            .filter(availability => availability.id === groupId)
            .map(availability => availability.timeLineItems)
            .flat()
        if (items.some(item => item.type === 'loading')) {
            return
        }

        const currentItemDuration: AdminTimelineItem = checkErrorReservation(
            classification,
            {
                type: 'current',
                id: 'current',
                group: groupId,
                contents: '',
                start_time: time.valueOf(),
                end_time: time.valueOf() + 60 * 60 * 1000,
            },
            reserveAvailabilitiesDuration,
        )
        if (!selectedDate) {
            return
        }
        if (!checkStartTimeIsInsideOfTargetDay(selectedDate, currentItemDuration.start_time)) {
            this.setState({illegalDateSelected: true})
            return
        }

        const {today, facilities} = this.state
        const reservationType =
            extractReservationTypeForDuration(classification, currentItemDuration, facilities, today)

        this.setState({
            currentItemDuration: currentItemDuration,
            reservationType: reservationType,
        })
    }

    handleTimeLineFacilityNameClick(groupId: Id): void {
        this.setState({selectedFacilityId: Number(groupId)})
    }

    handleReservationAvailableOvernight(facilityId: number): void {
        const {selectedDate, facilities, today} = this.state
        if (!selectedDate) {
            throw new Error('selectedDate is undefined')
        }

        const currentItemOvernight: CurrentItemOvernight = {
            facilityId: facilityId,
            startDate: selectedDate.clone(),
            stayCount: NUMBER_OF_TIMES_TO_STAY.VOL_1,
        }

        const reservationType = extractReservationTypeForOvernight(
            this.props.classification,
            currentItemOvernight,
            facilities,
            today,
        )

        this.setState({
            currentItemOvernight: {
                facilityId: facilityId,
                startDate: selectedDate.clone(),
                stayCount: NUMBER_OF_TIMES_TO_STAY.VOL_1,
            },
            reservationType: reservationType,
        })
    }

    handleFacilityInfoDialogClose(): void {
        this.setState({selectedFacilityId: null})
    }

    handleChangeReservationTitle(title: string): void {
        this.setState({reservationTitle: title})
    }

    handleChangeReservationTerm(currentItemDuration: AdminTimelineItem): void {
        const {today, facilities, reserveAvailabilitiesDuration, selectedDate} = this.state
        const {classification} = this.props
        if (!selectedDate) {
            return
        }
        if (!checkStartTimeIsInsideOfTargetDay(selectedDate, currentItemDuration.start_time)) {
            return
        }

        const reservationType =
            extractReservationTypeForDuration(classification, currentItemDuration, facilities, today)

        const updatedCurrentItem = checkErrorReservation(
            classification,
            currentItemDuration,
            reserveAvailabilitiesDuration,
        )

        this.setState({
            currentItemDuration: updatedCurrentItem,
            reservationType,
        })
    }

    handleChangeStayCount(stayCount: NUMBER_OF_TIMES_TO_STAY): void {
        const {currentItemOvernight} = this.state
        if (!currentItemOvernight) {
            return
        }

        const newItem: CurrentItemOvernight = {
            ...currentItemOvernight,
            stayCount,
        }

        this.setState({currentItemOvernight: newItem})
    }

    renderFacilityInfoDialog(): ReactNode {
        if (this.state.selectedFacilityId === null) {
            return null
        }

        return <>
            <Dialog
                id={'pp-dialog'}
                open={this.state.selectedFacilityId !== null}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                fullWidth
                maxWidth={'md'}
            >
                <ARFacilityInfoDetailsComponent
                    {...this.props}
                    condominiumCd={this.props.condominiumCd}
                    facilityId={this.state.selectedFacilityId}
                    facilitiesRepo={this.props.facilitiesRepo}
                    onClose={this.handleFacilityInfoDialogClose}
                />
            </Dialog>
        </>
    }

    handleSubmitDuration(reservationClass: ReservationClass): void {
        const {reservationType, reservationTitle, currentItemDuration, ridgeInfos, holidays} = this.state
        if (!currentItemDuration) {
            throw new Error('currentItemDuration is null')
        }
        if (!reservationType) {
            throw new Error('reservationType is null')
        }

        const startDateTime = moment(currentItemDuration.start_time)
        const endDateTime = moment(currentItemDuration.end_time)
        const {condominiumCd} = this.props

        const facilityId = convertToFacilityId(currentItemDuration.group)
        const reservationInfo = createReservationInfoDuration(
            reservationClass,
            this.props.location.state ? this.props.location.state.reservationInfo : undefined,
            reservationType,
            reservationTitle,
            startDateTime,
            endDateTime,
            facilityId,
        )

        const locationStateToNext = lsHelper.toObject({
            // @ts-ignore
            facilityData: null,
            // @ts-ignore
            cashPaymentStatus: null,

            ...(this.props.location.state || {}),

            holidays: holidays === null ? [] : holidays,
            facilityId: facilityId,
            ridgeInfos: ridgeInfos,
            reservationInfo: reservationInfo,
            previousPageUrl: `/admin/condominiums/${condominiumCd}/${reservationClass}-reserve/select-facility`,
            previousPageName: '予約日時確認',
        })
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/${reservationClass}-reserve/select-user`,
            {
                replace: true,
                state: {...locationStateToNext},
            },
        )
    }

    handleSubmitOvernight(reservationClass: ReservationClass): void {
        const {reservationType, reservationTitle, currentItemOvernight, ridgeInfos} = this.state
        if (!currentItemOvernight) {
            throw new Error('currentItemOvernight is null')
        }
        if (!reservationType) {
            throw new Error('reservationType is null')
        }

        const startDate = currentItemOvernight.startDate
        const stayCount = currentItemOvernight.stayCount
        const {condominiumCd} = this.props

        const facilityId = convertToFacilityId(currentItemOvernight.facilityId)
        const reservationInfo = createReservationInfoOvernight(
            reservationClass,
            this.props.location.state ? this.props.location.state.reservationInfo : undefined,
            reservationType,
            reservationTitle,
            startDate,
            stayCount,
            facilityId,
        )

        const locationStateToNext = lsHelper.toObject({
            // @ts-ignore
            facilityData: null,
            // @ts-ignore
            cashPaymentStatus: null,

            ...(this.props.location.state || {}),

            holidays: [],
            facilityId: facilityId,
            ridgeInfos: ridgeInfos,
            reservationInfo: reservationInfo,
            previousPageUrl: `/admin/condominiums/${condominiumCd}/${reservationClass}-reserve/select-facility`,
            previousPageName: '予約日時確認',
        })
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/${reservationClass}-reserve/select-user`,
            {
                replace: true,
                state: {...locationStateToNext},
            },
        )
    }

    renderStepper(classification: ReservationClass): ReactNode {
        return classification === ReservationClass.AGENT
            ? <Box height={'108px'} bgcolor={'#ffffff'} padding={'24px'}>
                <AdminReserveStepper
                classification={ReservationClass.AGENT}
                step={AdminAgentReserveSteps.SELECT_FACILITY}
                hasOption={false}
            />
            </Box>
            :
            <Box height={'108px'} bgcolor={'#ffffff'} padding={'24px'}>
                <AdminReserveStepper
                classification={ReservationClass.MANAGER}
                step={AdminManagerReserveSteps.SELECT_FACILITY}
                hasOption={false}
            />
            </Box>
    }

    renderOperationMessage(): ReactNode {
        const {selectedDate, facilityCategories} = this.state

        const dateIsNotSelected: boolean = !selectedDate
        const categoryIsNotSelected: boolean =
            (facilityCategories.filter(category => category.selected).length === 0)

        return <Box mt={'10px'} mb={'10px'}>
            {
                (dateIsNotSelected || categoryIsNotSelected)
                    ? (<div>施設の絞り込み条件および利用希望日を選択すると、ここに施設の空き状況が表示されます。</div>)
                    : (<>
                        <div>施設の空き状況をクリックすると、宿泊数または時間を設定できます。</div>
                        <div>施設名をクリックすると、施設の詳細が確認できます。</div>
                    </>)
            }
        </Box>
    }

    renderMain(today: moment.Moment): ReactNode {
        const {
            facilityCategories, selectedDate,
            reserveAvailabilitiesOvernight,
            currentItemDuration,
            timelineInitialDateTime,
            limitStartDateTime,
            limitEndDateTime,
            holidays,
        } = this.state
        if (facilityCategories.length === 0) {
            return '予約可能な施設がありません。'
        }

        const reserveAvailabilitiesOvernightInSelectedDay: OvernightFacilityReserveAvailability[] =
            reserveAvailabilitiesOvernight.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    status: item.dailyStatus ? item.dailyStatus[0].status : undefined,
                }
            })

        const hideWhenAccessIE11AndNeedToShowDialog: boolean = (isIE && currentItemDuration !== null)
        return <>
            <Box mt={'10px'}/>
            <StickyDiv>
                <FlexStartRowFlexContainer>
                    <Box mr={'20px'} className={'sticky'}>
                        <FullWidthColumnFlexContainer>
                            <FacilityCategoryFilter
                                facilityCategories={facilityCategories}
                                onChangeSelectState={this.handleChangeCategory}
                            />
                            <Box height={'15px'}/>
                            <DateFilter
                                today={today}
                                selectedDay={selectedDate}
                                holidays={holidays === null ? [] : holidays}
                                onSelectDay={this.handleChangeDate}
                            />
                        </FullWidthColumnFlexContainer>
                    </Box>

                    <FullWidthLeftColumnFlexContainer>
                        {this.renderOperationMessage()}
                        {
                            selectedDate && limitStartDateTime && limitEndDateTime &&
                            <>
                                <ARReservationStatusViewOvernight
                                    facilities={reserveAvailabilitiesOvernightInSelectedDay}
                                    onClickName={this.handleTimeLineFacilityNameClick}
                                    onClickStatus={this.handleReservationAvailableOvernight}
                                />
                                {
                                    hideWhenAccessIE11AndNeedToShowDialog
                                        ? null
                                        : timelineInitialDateTime && <ARReservationStatusViewDuration
                                        activeDay={selectedDate}
                                        initialVisibleStartDateTime={timelineInitialDateTime}
                                        limitStartDateTime={limitStartDateTime}
                                        limitEndDateTime={limitEndDateTime}
                                        areaWidth={this.state.areaWidth}
                                        onClickTimeline={this.handleTimelineClick}
                                        onClickName={this.handleTimeLineFacilityNameClick}
                                        facilities={this.withCurrentItemDuration()}
                                    />
                                }
                            </>
                        }
                    </FullWidthLeftColumnFlexContainer>
                </FlexStartRowFlexContainer>
            </StickyDiv>

            {this.renderInputFormDialogDuration()}
            {this.renderInputFormDialogOvernight()}
            {this.renderFacilityInfoDialog()}
            <Snackbar
                open={this.state.illegalDateSelected}
                onClose={this.handleCloseSnackbar}
                TransitionComponent={SlideTransition}
                message={
                    <>
                        <div>クリックできるのは、利用希望日で指定した日付の24時間のみです。</div>
                        <div>この日付で予約したい場合は、利用希望日を変更してください。</div>
                    </>
                }
                action={
                    <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleCloseSnackbar}>
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                }
            />
        </>
    }

    handleCloseSnackbar(event: React.SyntheticEvent<any> | Event, reason?: SnackbarCloseReason): void {
        if (reason === 'clickaway') {
            return
        }
        this.setState({illegalDateSelected: false})
    }

    withCurrentItemDuration(): DurationFacilityReserveAvailability[] {
        const {currentItemDuration, reserveAvailabilitiesDuration} = this.state
        if (currentItemDuration === null) {
            return reserveAvailabilitiesDuration
        }

        const facilityId = convertToFacilityId(currentItemDuration.group)

        const updateIndex =
            reserveAvailabilitiesDuration
                .findIndex(availability => availability.id === facilityId)
        if (updateIndex === -1) {
            return reserveAvailabilitiesDuration
        }

        return [
            ...reserveAvailabilitiesDuration.slice(0, updateIndex),
            {
                ...reserveAvailabilitiesDuration[updateIndex],
                timeLineItems: [
                    ...reserveAvailabilitiesDuration[updateIndex].timeLineItems,
                    currentItemDuration,
                ],
            },
            ...reserveAvailabilitiesDuration.slice(updateIndex + 1),
        ]
    }

    render(): ReactNode {
        const {today} = this.state
        if (!today) {
            return null
        }
        return <>
            {this.renderStepper(this.props.classification)}
            {this.renderMain(today)}
        </>
    }

    renderInputFormDialogDuration(): ReactNode {
        const {classification} = this.props
        const {reservationTitle, currentItemDuration, selectedDate, reservationType, editMode, holidays} = this.state
        if (!selectedDate) {
            return null
        }
        if (!currentItemDuration) {
            return null
        }
        const facilityWithAvailability = this.withCurrentItemDuration().find(facility => {
            return facility.id === currentItemDuration.group
        })
        if (!facilityWithAvailability) {
            return null
        }

        const currentItemMoment = moment(currentItemDuration.start_time)
        const dialogInitialDate: moment.Moment = currentItemMoment.add(-2, 'hours')
        const reservable = editMode && currentItemDuration.error === undefined
        let messages: MessagePair[] = []
        if (!editMode) {
            messages = [{message: Messages.IRESR0009.toString()}]
        } else if (!reservationType) {
            messages = [{message: '指定の日付は予約受付け開始前です。他の日を指定してくだい。'}]
        }

        return <>
            <Dialog id={'pp-dialog'}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    open={currentItemDuration !== null} fullWidth maxWidth={'md'}
                    PaperProps={{
                        sx: {
                            wudth: '90vw',
                            maxWidth: '960px',
                            maxHeight: 'calc(100vh - 64px)',
                            height: 'auto'
                        }
                    }}
            >
                <StyledDialogTitle><AdminPageHeadingArea title={'予約情報入力'}/></StyledDialogTitle>
                <DialogContent
                    sx={{
                        flex: 'unset',
                        overflowY: 'auto',
                    }}>
                    <FormErrorMessage messages={messages}/>
                    <ARSelectFacilityInputFormDuration
                        classification={classification}
                        reservationType={reservationType}
                        activeDay={selectedDate}
                        facilityWithAvailability={facilityWithAvailability}
                        reservationTitle={reservationTitle}
                        currentItem={currentItemDuration}
                        initialVisibleStartDateTime={dialogInitialDate}
                        holidays={holidays === null ? [] : holidays}
                        onClickTimeline={this.handleTimelineClick}
                        onChangeReservationTitle={this.handleChangeReservationTitle}
                        onChangeReservationTerm={this.handleChangeReservationTerm}
                    />
                </DialogContent>
                <DialogActions
                    sx={{
                        pt: '0',
                        flexShrink: '0'
                    }}>
                    <FullWidthRowFlexContainer>
                        <BackLink onClick={() => {
                            this.setState({currentItemDuration: null})
                        }}>
                            ご利用日・施設を選び直す
                        </BackLink>
                        {
                            classification === ReservationClass.AGENT &&
                            <AdminPrimaryButton
                                disabled={!reservable || !reservationType}
                                onClick={() => this.handleSubmitDuration(classification)}
                            >
                                利用者・支払い方法選択に進む
                            </AdminPrimaryButton>
                        }
                        {
                            classification === ReservationClass.MANAGER &&
                            <AdminPrimaryButton
                                disabled={!reservable || !reservationType}
                                onClick={() => this.handleSubmitDuration(classification)}
                            >利用者選択に進む</AdminPrimaryButton>
                        }
                    </FullWidthRowFlexContainer>
                </DialogActions>
            </Dialog>
        </>
    }

    renderInputFormDialogOvernight(): ReactNode {
        const {classification} = this.props
        const {
            currentItemOvernight,
            reserveAvailabilitiesOvernight,
            reservationTitle,
            reservationType,
            editMode,
        } = this.state

        if (!currentItemOvernight) {
            return null
        }

        const facilityWithAvailability =
            reserveAvailabilitiesOvernight.find(item => item.id === currentItemOvernight.facilityId)

        if (!facilityWithAvailability || !facilityWithAvailability.dailyStatus) {
            return null
        }

        const targetStatus = facilityWithAvailability.dailyStatus[0].status
        const reservableStatus = classification === ReservationClass.AGENT ? targetStatus === 'blank' : targetStatus !== 'otherReservation'
        const reservable: boolean = editMode && reservableStatus
        let messages: MessagePair[] = []
        if (!editMode) {
            messages = [{message: Messages.IRESR0009.toString()}]
        } else if (!reservationType) {
            messages = [{message: '指定の日付は予約受付け開始前です。他の日を指定してくだい。'}]
        }

        return (<>
            <Dialog id={'pp-dialog'}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    open={currentItemOvernight !== null} fullWidth maxWidth={'sm'}>
                <StyledDialogTitle><AdminPageHeadingArea title={'予約情報入力'}/></StyledDialogTitle>
                <DialogContent>
                    <FormErrorMessage messages={messages}/>
                    <ARSelectFacilityInputFormOvernight
                        classification={classification}
                        facilityWithAvailability={facilityWithAvailability}
                        reservationTitle={reservationTitle}
                        reservationType={reservationType}
                        currentItem={currentItemOvernight}
                        onChangeReservationTitle={this.handleChangeReservationTitle}
                        onChangeStayCount={this.handleChangeStayCount}
                    />
                </DialogContent>
                <DialogActions>
                    <FullWidthRowFlexContainer>
                        <BackLink onClick={() => {
                            this.setState({currentItemOvernight: null})
                        }}>
                            ご利用日・施設を選び直す
                        </BackLink>
                        {
                            classification === ReservationClass.AGENT &&
                            <AdminPrimaryButton
                                disabled={!reservable || !reservationType}
                                onClick={() => this.handleSubmitOvernight(classification)}
                            >
                                利用者・支払い方法選択に進む
                            </AdminPrimaryButton>
                        }
                        {
                            classification === ReservationClass.MANAGER &&
                            <AdminPrimaryButton
                                disabled={!reservable || !reservationType}
                                onClick={() => this.handleSubmitOvernight(classification)}
                            >
                                利用者選択に進む
                            </AdminPrimaryButton>
                        }
                    </FullWidthRowFlexContainer>
                </DialogActions>
            </Dialog>
        </>)
    }
}

export default createAdminPage(AdminReserveSelectFacilityPage)

const judgeStatusTypeOvernight = (response: AdminReserveAvailabilityOvernight, selectedDate: moment.Moment) => {
    const existOtherReservation = response.otherReserves
        .some(otherReservation => {
            const date = moment(otherReservation.date)
            return selectedDate.isSame(date, 'day')
        })
    if (existOtherReservation) {
        return 'otherReservation'
    }

    const isInOutOfHours = response.outOfHours
        .some(outOfHours => {
            const date = moment(outOfHours.date)
            return selectedDate.isSame(date, 'day')
        })
    if (isInOutOfHours) {
        return 'outsideHours'
    }

    return isInOutOfHours ? 'outsideHours' : 'blank'
}

const judgeStatusTypesOvernight = (
    response: AdminReserveAvailabilityOvernight,
    selectedDate: moment.Moment,
    dayCount: number) => {
    let dailyStatus: StatusInOneDay[] = []

    for (let i = 0; i < dayCount; i++) {
        const targetDay: Moment = selectedDate.clone().add(i, 'day')
        const status = judgeStatusTypeOvernight(response, targetDay)

        dailyStatus = [...dailyStatus, {date: targetDay, status: status}]
    }

    return dailyStatus
}

const extractDataFromLocationState = (
    facilities: FacilityForAdmin[],
    locationState: Optional<AdminReserveLocationState>,
    today: Nullable<moment.Moment>,
    classification: ReservationClass,
): {
    selectedDate: Optional<moment.Moment>,
    selectedCategoryIdList: number[],
    reservationTitle: string,
    currentItemDuration: Nullable<AdminTimelineItem>,
    currentItemOvernight: Nullable<CurrentItemOvernight>,
    reservationType: Nullable<RESERVATION_TYPE>
} => {
    if (!locationState) {
        return {
            selectedDate: undefined,
            selectedCategoryIdList: [],
            reservationTitle: '',
            currentItemDuration: null,
            currentItemOvernight: null,
            reservationType: null,
        }
    }

    const {reservationInfo} = locationState
    const locationStateData = extractDataFromLocationStateByRentalType(reservationInfo)
    const reservationType: Nullable<RESERVATION_TYPE> = extractReservationType(
        reservationInfo.facilityId,
        moment(reservationInfo.startDate),
        facilities,
        today,
        classification,
    )

    return {
        ...locationStateData,
        reservationType: reservationType,
        selectedCategoryIdList: facilities
            .filter(facility => {
                return facility.facilityId === reservationInfo.facilityId
            })
            .map(facility => {
                return facility.categoryId
            }),
    }
}

const extractDataFromLocationStateByRentalType = (reservationInfo: ReservationInfo): {
    currentItemDuration: Nullable<AdminTimelineItem>,
    currentItemOvernight: Nullable<CurrentItemOvernight>,
    selectedDate: Optional<moment.Moment>,
    reservationTitle: string,
} => {
    switch (reservationInfo.type) {
        case FacilityRentalType.DURATION:
            return {
                currentItemOvernight: null,
                ...extractDataFromLocationStateDuration(reservationInfo),
            }
        case FacilityRentalType.OVERNIGHT:
            return {
                currentItemDuration: null,
                ...extractDataFromLocationStateOvernight(reservationInfo),
            }
    }
}

const extractDataFromLocationStateDuration = (reservationInfo: ReservationInfo): {
    currentItemDuration: Nullable<AdminTimelineItem>,
    selectedDate: Optional<moment.Moment>,
    reservationTitle: string,
} => {
    if (reservationInfo.type !== FacilityRentalType.DURATION) {
        throw new Error('not match type')
    }
    const startMoment = moment(`${reservationInfo.startDate}T${reservationInfo.startTime}`)

    return {
        selectedDate: startMoment.clone(),
        reservationTitle: reservationInfo.reservationTitle,
        currentItemDuration: {
            type: 'current',
            id: 'current',
            group: reservationInfo.facilityId,
            contents: '',
            start_time: startMoment.valueOf(),
            end_time: moment(`${reservationInfo.endDate}T${reservationInfo.endTime}`).valueOf(),
        },
    }
}

const extractDataFromLocationStateOvernight = (reservationInfo: ReservationInfo): {
    currentItemOvernight: Nullable<CurrentItemOvernight>,
    selectedDate: Optional<moment.Moment>,
    reservationTitle: string,
} => {
    if (reservationInfo.type !== FacilityRentalType.OVERNIGHT) {
        throw new Error('not match type')
    }
    const startMoment = moment(reservationInfo.startDate)

    return {
        selectedDate: startMoment,
        reservationTitle: reservationInfo.reservationTitle,
        currentItemOvernight: {
            facilityId: reservationInfo.facilityId,
            startDate: startMoment.clone(),
            stayCount: NUMBER_OF_TIMES_TO_STAY.codeToEnumConstants(String(reservationInfo.stayCount)),
        },
    }
}

const extractReservationType = (
    facilityId: number,
    startDateTime: Moment,
    facilities: FacilityForAdmin[],
    today: Nullable<moment.Moment>,
    classification: ReservationClass,
): Nullable<RESERVATION_TYPE> => {
    const facilityForAdmin = facilities.find(facility => {
        return facility.facilityId === facilityId
    })
    if (!today || !facilityForAdmin) {
        return null
    }

    if (classification === ReservationClass.MANAGER) {
        return RESERVATION_TYPE.FIRST_COME
    }

    let reservationType = calculateReservationType(
        startDateTime,
        today,
        facilityForAdmin.lotteryAvailability
            ? AVAILABLE_OR_NOT.AVAILABLE : AVAILABLE_OR_NOT.UNAVAILABLE,
        {
            facilityReserveLotteryStart: facilityForAdmin.reserveLotteryStart,
            facilityReserveLotteryEnd: facilityForAdmin.reserveLotteryEnd,
            facilityReserveLotteryMonth: facilityForAdmin.reserveLotteryMonth,
            facilityReserveConfirmLimit: facilityForAdmin.reserveConfirmLimit,
            facilityReserveFasterPeriod: facilityForAdmin.reserveFasterPeriod,
        },
    )
    if (reservationType === null) {
        reservationType = RESERVATION_TYPE.FIRST_COME
    }
    return reservationType
}

const extractReservationTypeForDuration = (
    classification: ReservationClass,
    currentItemDuration: Nullable<AdminTimelineItem>,
    facilities: FacilityForAdmin[],
    today: Nullable<moment.Moment>,
): Nullable<RESERVATION_TYPE> => {
    if (!currentItemDuration) {
        return null
    }

    return extractReservationType(
        convertToFacilityId(currentItemDuration.group),
        moment(currentItemDuration.start_time),
        facilities,
        today,
        classification,
    )
}
const extractReservationTypeForOvernight = (
    classification: ReservationClass,
    currentItemOvernight: Nullable<CurrentItemOvernight>,
    facilities: FacilityForAdmin[],
    today: Nullable<moment.Moment>,
): Nullable<RESERVATION_TYPE> => {
    if (!currentItemOvernight) {
        return null
    }

    return extractReservationType(
        convertToFacilityId(currentItemOvernight.facilityId),
        currentItemOvernight.startDate,
        facilities,
        today,
        classification,
    )
}

const createReservationInfoDuration = (
    reservationClass: ReservationClass,
    locationStateReservationInfo: Optional<ReservationInfo>,
    reservationType: RESERVATION_TYPE,
    reservationTitle: string,
    startDateTime: Moment,
    endDateTime: Moment,
    facilityId: number,
): ReservationInfo => {
    let reservationInfo: ReservationInfo
    if (reservationClass === ReservationClass.AGENT) {
        reservationInfo = {
            // @ts-ignore
            userInfo: null,
            // @ts-ignore
            paymentType: null,
            // @ts-ignore
            selectedRoomsOrDisabled: null,
            // @ts-ignore
            reservationOptionInfos: null,

            ...(locationStateReservationInfo ? locationStateReservationInfo : {}) as AgentReservationInfo,

            classification: ReservationClass.AGENT,
            type: FacilityRentalType.DURATION,
            reserveType: reservationType,
            reservationTitle: reservationTitle,
            startDate: startDateTime.format('YYYY-MM-DD'),
            startTime: startDateTime.format('HH:mm:ss'),
            endDate: endDateTime.format('YYYY-MM-DD'),
            endTime: endDateTime.format('HH:mm:ss'),
            facilityId: facilityId,
        }
    } else if (reservationClass === ReservationClass.MANAGER) {
        reservationInfo = {
            // @ts-ignore
            userInfo: null,
            // @ts-ignore
            reservationOptionInfos: null,

            ...(locationStateReservationInfo ? locationStateReservationInfo : {}) as ManagerReservationInfo,

            classification: ReservationClass.MANAGER,
            type: FacilityRentalType.DURATION,
            reserveType: reservationType,
            reservationTitle: reservationTitle,
            startDate: startDateTime.format('YYYY-MM-DD'),
            startTime: startDateTime.format('HH:mm:ss'),
            endDate: endDateTime.format('YYYY-MM-DD'),
            endTime: endDateTime.format('HH:mm:ss'),
            facilityId: facilityId,
        }
    } else {
        throw new Error('not implemented yet')
    }
    if (locationStateReservationInfo && locationStateReservationInfo.facilityId !== facilityId) {
        reservationInfo.reservationOptionInfos = null
    }

    return reservationInfo
}

const createReservationInfoOvernight = (
    reservationClass: ReservationClass,
    locationStateReservationInfo: Optional<ReservationInfo>,
    reservationType: RESERVATION_TYPE,
    reservationTitle: string,
    startDate: Moment,
    stayCount: NUMBER_OF_TIMES_TO_STAY,
    facilityId: number,
): ReservationInfo => {
    let reservationInfo: ReservationInfo
    if (reservationClass === ReservationClass.AGENT) {
        reservationInfo = {
            // @ts-ignore
            userInfo: null,
            // @ts-ignore
            paymentType: null,
            // @ts-ignore
            selectedRoomsOrDisabled: null,
            // @ts-ignore
            reservationOptionInfos: null,

            ...(locationStateReservationInfo ? locationStateReservationInfo : {}) as AgentReservationInfo,

            classification: ReservationClass.AGENT,
            type: FacilityRentalType.OVERNIGHT,
            reserveType: reservationType,
            reservationTitle: reservationTitle,
            startDate: startDate.format('YYYY-MM-DD'),
            stayCount: Number(stayCount.value),
            facilityId: facilityId,
        }
    } else if (reservationClass === ReservationClass.MANAGER) {
        reservationInfo = {
            // @ts-ignore
            userInfo: null,
            // @ts-ignore
            reservationOptionInfos: null,

            ...(locationStateReservationInfo ? locationStateReservationInfo : {}) as ManagerReservationInfo,

            classification: ReservationClass.MANAGER,
            type: FacilityRentalType.OVERNIGHT,
            reserveType: reservationType,
            reservationTitle: reservationTitle,
            startDate: startDate.format('YYYY-MM-DD'),
            stayCount: Number(stayCount.value),
            facilityId: facilityId,
        }
    } else {
        throw new Error('not implemented yet')
    }
    if (locationStateReservationInfo && locationStateReservationInfo.facilityId !== facilityId) {
        reservationInfo.reservationOptionInfos = null
    }

    return reservationInfo
}

const checkErrorReservation = (
    reservationClass: ReservationClass,
    item: AdminTimelineItem,
    reserveAvailabilitiesDuration: DurationFacilityReserveAvailability[],
): AdminTimelineItem => {

    if (item.start_time >= item.end_time) {
        return {
            ...item,
            error: 'illegal',
        }
    }

    const items = reserveAvailabilitiesDuration
        .filter(availability => availability.id === item.group)
        .map(availability => availability.timeLineItems)
        .flat()

    const isOverlapped = items
        .filter(other => {
            if (other.type === 'outsideHours' && reservationClass === ReservationClass.MANAGER) {
                return false
            } else {
                return other.type !== 'current'
            }
        })
        .some(other => {
            return item.end_time > other.start_time && item.start_time < other.end_time
        })

    return {
        ...item,
        error: isOverlapped ? 'overlap' : undefined,
    }
}

const checkStartTimeIsInsideOfTargetDay = (
    selectedDate: moment.Moment,
    startTime: number,
): boolean => {
    if (selectedDate.startOf('day').valueOf() > startTime) {
        return false
    }

    // noinspection RedundantIfStatementJS
    if (selectedDate.endOf('day').valueOf() <= startTime) {
        return false
    }

    return true
}

const formatTimelineItemTooltip = (dateTimeString: string): string => {
    const dateTime = moment(dateTimeString)
    return dateTime.format('M月D日 H:mm')
}

const SlideTransition = React.forwardRef<unknown, TransitionProps>(
// @ts-ignore
    (props, ref) => <Slide direction="up" ref={ref} {...props} />,
)
